const validate = (values) => {
    const errors = {};
    
    if (!values.recordingTypeId) {
        errors.recordingTypeId = 'Please select recording type';
    }
    if (!values.behaviorsReductionId) {
        errors.behaviorsReductionId = 'Please select behavior';
    }
    if(!values.graphTypeId) {
        errors.graphTypeId = 'Please select graph type';
    }
   
    return errors;
};
export default validate;




// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionBatchGraph/BehaviourGraph/validate.js